"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSITIVE_DIFF = exports.MUI_ROW = exports.MUI_CELL = exports.COLLAPSED_COLUMN_HEADER = exports.COLLAPSED_CELL = void 0;
var COLLAPSED_COLUMN_HEADER = exports.COLLAPSED_COLUMN_HEADER = 'collapsed-column-header';
var COLLAPSED_CELL = exports.COLLAPSED_CELL = 'collapsed-cell';
var MUI_CELL = exports.MUI_CELL = 'MuiDataGrid-cell';
var MUI_ROW = exports.MUI_ROW = 'MuiDataGrid-row';
var POSITIVE_DIFF = exports.POSITIVE_DIFF = 'positive';